import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { siteContent } from '../../data/siteContent';
import { langPath } from '../../utils/langPath';

const Navigation = ({ mobile = false, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { language } = useLanguage();

  const menuItems = language === 'fr' ? siteContent.navigation.mainFr : siteContent.navigation.mainEn;

  const handleNavigate = (href) => {
    // Handle anchor links (e.g. /#progresser)
    if (href.includes('#')) {
      const [path, hash] = href.split('#');
      // path peut être "" (cas /#xxx) → on cible la home de la langue active
      const targetPath = langPath(path || '/', language);
      if (location.pathname === targetPath) {
        // Already on the page, just scroll
        const el = document.getElementById(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      } else {
        // Navigate to page first, then scroll
        navigate(targetPath);
        setTimeout(() => {
          const el = document.getElementById(hash);
          if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      navigate(langPath(href, language));
      window.scrollTo(0, 0);
    }
    if (mobile && onClose) {
      onClose();
    }
  };

  // Check active state : compare avec le path préfixé lang
  const isItemActive = (href) => {
    if (href.includes('#')) {
      const homePath = langPath('/', language);
      return location.pathname === homePath && location.hash === '#' + href.split('#')[1];
    }
    return location.pathname === langPath(href, language);
  };

  return (
    <nav>
      <ul className={mobile ? 'space-y-2' : 'flex items-center gap-10'}>
        {menuItems.map((item, index) => {
          const isActive = isItemActive(item.href);

          return (
            <li key={index} className="relative">
              <button
                className={mobile
                  ? `w-full text-left px-4 py-2 transition rounded font-bold ${isActive ? 'bg-blue-50 text-blue-700 dark:bg-white/10 dark:text-white' : 'text-gray-700 hover:bg-gray-100 hover:text-gray-900 dark:text-white/60 dark:hover:bg-white/5 dark:hover:text-white'}`
                  : `transition font-bold py-2 relative group text-white/80 ${isActive ? '' : 'hover:text-white'}`
                }
                onClick={() => handleNavigate(item.href)}
              >
                {item.label}
              </button>

              {!mobile && isActive && (
                <div className="absolute -bottom-1 left-0 right-0 h-[4px] bg-blue-600 dark:bg-white rounded-full shadow-sm shadow-black/10 animate-in fade-in slide-in-from-bottom-1 duration-200" />
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Navigation;
